import React, { useState, useEffect } from 'react';
import { FiPhone, FiMessageSquare } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import settings from '../config/settings';

const FloatingCTAs = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const controlNavbar = () => {
      if (typeof window !== 'undefined') {
        if (window.scrollY > lastScrollY && window.scrollY > 100) {
          setIsVisible(false);
        } else {
          setIsVisible(true);
        }
        setLastScrollY(window.scrollY);
      }
    };

    window.addEventListener('scroll', controlNavbar);
    return () => window.removeEventListener('scroll', controlNavbar);
  }, [lastScrollY]);

  return (
    <div 
      className={`floating-ctas hidden md:flex fixed bottom-8 right-6 z-[120] flex flex-col space-y-4 transition-all duration-500 transform ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
      }`}
    >
      {/* WhatsApp Button */}
      <div className="group relative">
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 px-3 py-1 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
          Chat with us on WhatsApp
        </span>
        <a
          href={settings.whatsapp.link}
          target="_blank"
          rel="noopener noreferrer"
          className="w-12 h-12 bg-green-500 text-white rounded-full shadow-2xl flex items-center justify-center hover:scale-105 transition-transform duration-200"
        >
          <SafeIcon icon={FiMessageSquare} className="w-6 h-6" />
        </a>
      </div>

      {/* Call Button */}
      <div className="group relative">
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 px-3 py-1 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
          Call {settings.siteName}
        </span>
        <a
          href={`tel:${settings.phones[0].number}`}
          className="w-12 h-12 bg-emerald-600 text-white rounded-full shadow-2xl flex items-center justify-center hover:scale-105 transition-transform duration-200"
        >
          <SafeIcon icon={FiPhone} className="w-6 h-6" />
        </a>
      </div>
    </div>
  );
};

export default FloatingCTAs;